module.exports = __webpack_public_path__ + "static/datacenter-cdc89d35f3d5dceb8434092fc41b913a.jpg";